import * as THREE from 'three'
import { modelArr } from "./model"
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import fyponhotspottexture from '../assets/images/fypon_texture.png';
import thermatruhotspottexture from '../assets/images/thermatru_texture.png';
import fbxHotspot from "../assets/models/hotspot-test.fbx"

let start = 0;
let fyponFlag = true;
let thermatruFlag = true;
const baseUrlaws = process.env.REACT_APP_S3_BUCKET_BASE_URL;

function GetPlaneMesh(size, map, pos, rot) {
    const planeMesh = new THREE.Mesh(new THREE.PlaneGeometry(size.w, size.h),
        new THREE.MeshStandardMaterial({ side: 2, map, transparent: size.w < 0.5 }));
    planeMesh.position.set(pos.x, pos.y, pos.z);
    planeMesh.rotation.y = Math.PI * rot / 180 + Math.PI;
    return planeMesh;
}

function loadHotSpotModel(self) {
    let that = self;
    new FBXLoader().load(fbxHotspot, (objHot) => {
        const vPos = new THREE.Box3().setFromObject(objHot)
        const vSize = vPos.getSize(new THREE.Vector3())
        const sclHot = 2 / vSize.x;
        objHot.scale.set(sclHot, sclHot, sclHot);
        self.hotSpotModel = objHot;
        __modalItem(that, objHot);
    });
}

function __modalItem(self, objHot) {
    let fypontexture = new THREE.TextureLoader().load(fyponhotspottexture);
    let thermatrutexture = new THREE.TextureLoader().load(thermatruhotspottexture);

    modelArr.forEach((modelItem) => {

        __backgroundImage(self, modelItem);

        if (modelItem?.imageElements) {
            __imageElements(self, modelItem?.imageElements, modelItem.key);
        }

        //Video Rendering Mesh
        if (modelItem.frames) {
            const key = modelItem.key;
            modelItem.frames.forEach(frame => {
                const { size, pos, rot, frameKey, scale } = frame;
                if (frameKey === "fypon_video") {
                    self.videoFrames.push({ key, pos, size, rot, scale, frameKey });
                    __fyponVideo(self, pos, size, rot, scale, frameKey, fyponFlag);
                    fyponFlag = false;
                }
                if (frameKey === "thermatru_video") {
                    self.videoFrames.push({ key, pos, size, rot, scale, frameKey });
                    __thermatruVideo(self, pos, rot, scale, frameKey, thermatruFlag);
                    thermatruFlag = false;
                }

            });
        }

        modelItem.hotspot.forEach((item, idx) => {
            const hotPos = item.pos, hotRot = item.rot, hotGroup = objHot.clone(), sclRing = Math.random() / 2; //  GetHotMesh();
            self.hotMeshArr.push(hotGroup);

            hotGroup.traverse((child) => {


                if (child instanceof THREE.Mesh) {
                    child.hotId = item.name;
                    child.textName = item.textKey;

                    if (child.name === 'main') {
                        child.material.side = THREE.DoubleSide;
                        child.material.needsUpdate = true
                        SetHotMat(child, 'main', undefined, item.color);
                    } else if (child.name.includes('over')) {
                        let mapHotOver = null
                        if (item.type === "fypon") {
                            mapHotOver = fypontexture
                        } else {
                            mapHotOver = thermatrutexture
                        }
                        self.hotOverArr.push(child);
                        SetHotMat(child, 'over', mapHotOver, item.color);
                    } else if (child.name.includes('ring')) {
                        self.hotRingArr.push(child);
                        SetHotMat(child, 'ring', undefined, sclRing, item.color);
                    } else if (child.name.includes('text')) {
                        child.visible = false;
                        child.scale.set(0.9, 1, 1)
                        if (child.name === item.textKey) {
                            child.scale.y = 0;
                            self.hotOverTextArr.push(child);
                            child.rotation.y = item.textRot.y
                        }
                    }
                }
            })

            hotGroup.modelKey = item.name;
            hotGroup.ref = item.ref;
            hotGroup.guided_path_show = false
            if (item.guided_path_show) {
                hotGroup.guided_path_show = true;
            }
            hotGroup.name = item.ref;
            hotGroup.position.set(hotPos.x, hotPos.y, hotPos.z);

            if (item.rotNeed) {
                hotGroup.rotation.set(hotRot.x, hotRot.y, hotRot.z);
            }
            hotGroup.visible = false
            self.modelGroup.add(hotGroup)
        })
    });
}

function __backgroundImage(self, modelItem) {
    // console.log("started",start)
    const loder = new THREE.TextureLoader();


    loder.load(baseUrlaws+'datas/tinified/' + modelItem.backImg, function (backMap) {

       
        backMap.hotId = modelItem.key;
        backMap.minFilter = THREE.LinearFilter;
        backMap.magFilter = THREE.LinearFilter;
        backMap.modelKey = modelItem.key;
        self.backMapArr.push(backMap);
        start++;
        // console.log("start",start)
        if (start > 11) {
            self.props.changeLoaderStatus(false)
            // console.log("ended")
        }else{
            self.props.changeLoaderStatus(true)

        }
    });


}

function __imageElements(self, images, key) {
    images.forEach(nav => {
        const { name, pos, link, rot } = nav;
        const geometry = new THREE.PlaneGeometry(3, 1.0, 1, 1);
        const material = new THREE.MeshBasicMaterial({ color: 0xFFFF00, side: THREE.DoubleSide, transparent: true, opacity: 0 });
        const plane = new THREE.Mesh(geometry, material);
        plane.rotation.y = rot.y;
        plane.name = name;
        plane.hotId = key;
        plane.position.set(pos.x, pos.y, pos.z);
        plane.link = link;
        plane.visible = false
        self.imageArr.push(plane);
        self.imageGroup.add(plane);
        // self.add(plane);
    });
}

function __fyponVideo(self, pos, size, rot, scale, key, flag) {
    if (flag) {
        const frameVideo = document.getElementById('fypon-video')
        const frameMap = new THREE.VideoTexture(frameVideo)
        const frameMesh = GetPlaneMesh(size, frameMap, pos, rot); // new THREE.Mesh(frameGeo, frameMat);
        frameMesh.scale.set(4.170, 4.100, 1);
        frameMesh.rotation.y = 1.731;
        if (scale) {
            frameMesh.scale.set(scale.x, scale.y, 1);
            frameMesh.rotation.set(rot.x, rot.y, rot.z);
        }
        frameMesh.hotId = key;
        frameMesh.name = key;
        frameMesh.needsUpdate = true
        self.frameGroup.add(frameMesh);
        frameMesh.visible = false;
    }
}

function __thermatruVideo(self, pos, rot, scale, key, flag) {
    if (flag) {
        const frameVideo = document.getElementById('thermatru-video')
        const frameMap = new THREE.VideoTexture(frameVideo);
        const frameMesh = GetPlaneMesh({ w: 2, h: 2 }, frameMap, pos, rot); // new THREE.Mesh(frameGeo, frameMat);
        frameMesh.position.set(pos.x, pos.y, pos.z);
        frameMesh.rotation.set(rot.x, rot.y, rot.z);
        frameMesh.scale.set(scale.x, scale.y, scale.z)
        frameMesh.hotId = key;
        frameMesh.name = key;
        self.frameGroup.add(frameMesh);
        frameMesh.visible = true;
        frameMesh.needsUpdate = true;
    }
}

function SetHotMat(mesh, key, mapHotOver, sclRing, color1) {
    const map = mapHotOver || undefined;
    const mainColor = mesh.hotId.includes('therma') ? 0xFF0000 : 0x0079C2; // 0x0877C1
    const color = key === 'over' ? 0xFFFFFF : mainColor;
    const opacity = key === 'main' ? 0.1 : 1;
    mesh.material = new THREE.MeshStandardMaterial({ transparent: true, side: 2, map, color: color, opacity });
    if (key === 'over') mesh.scale.z = 0.01;
    else if (key === 'ring') {
        if (mesh.name === 'ring-1') sclRing += 0.5;
        mesh.sclRing = sclRing;
        mesh.material.opacity = sclRing;
        mesh.scale.set(sclRing, sclRing, 1);
        //mesh.material.transparent = false;
    }
}

function animateRing(ringArr) {
    ringArr.forEach(ring => {
        ring.sclRing += 0.005;
        if (ring.sclRing > 1) ring.sclRing = 0;
        ring.scale.set(ring.sclRing, ring.sclRing, 1);
        ring.material.opacity = 1 - ring.sclRing;
    });
}

function ScaleOver(hotOverTextArr, selectedHotspot, hoverArr, hotId) {
    const axis = ['z', 'y'];
    hoverArr.forEach(child => {
        if (child.hotId !== hotId && child.scale.z > 0) {
            child.scale.z -= 0.05;
            if (child.scale.z < 0) child.scale.z = 0;
        }
        if (selectedHotspot) {
            if (child.hotId === hotId && child.scale.z < 1) {
                child.scale.z += 0.05;
                if (child.scale.z > 1) child.scale.z = 1;
            }
        }
    });

    hotOverTextArr.forEach((child) => {
        if (child.hotId !== hotId && child.scale[axis[1]] > 0) {
            child.scale[axis[1]] -= 0.05;
            if (child.scale[axis[1]] < 0) {
                child.scale[axis[1]] = 0;
                child.visible = false;
            } else if (child.scale[axis[1]] === 0 && child.visible) {
                child.visible = false;
            }
        }

        if (selectedHotspot) {
            if (child.hotId === selectedHotspot.hotId && child.scale[axis[1]] < 1) {
                if (!child.visible) child.visible = true;
                child.visible = true;
                child.scale[axis[1]] += 0.05;
                if (child.scale[axis[1]] > 1) child.scale[axis[1]] = 1;
            }
        }
    });
}

export { SetHotMat, animateRing, ScaleOver, loadHotSpotModel };